import { paymentsClient } from '../axiosInstance';
import { ISubscription, IAddUpdateSubscriptionData } from 'features/billing/subscription/subscriptionTypes';

const subscriptionsURL = process.env.REACT_APP_PAYMENTS_API + '/subscriptions'

export const fetchSubscriptionById = async (subscriptionId: string) => {
    return await paymentsClient.get<ISubscription>(subscriptionsURL + `/${subscriptionId}`);
}

export const fetchSubscriptionByOrganozationId = async (organozationId: number) => {
    return await paymentsClient.get<ISubscription>(subscriptionsURL + `/organizations/${organozationId}`);
}

export const addNewSubscription = async (organizationId: number, model: IAddUpdateSubscriptionData) => {
    return await paymentsClient.post<ISubscription>(
        subscriptionsURL + `/organizations/${organizationId}`,
        model);
}

export const changeSubscriptionInfo = async (model: IAddUpdateSubscriptionData) => {
    return await paymentsClient.patch<ISubscription>(
        subscriptionsURL + `/${model.subscriptionId}`,
        model);
}

export const cancelSubscriptionById = async (subscriptionId: string) => {
    return await paymentsClient.patch<ISubscription>(
        subscriptionsURL + `/${subscriptionId}/cancel`);
}

export const reactivateSubscriptionById = async (subscriptionId: string) => {
    return await paymentsClient.patch<ISubscription>(
        subscriptionsURL + `/${subscriptionId}/reactivate`);
}
